import { render } from "./JobTemplateSelection.vue?vue&type=template&id=7d96a5e6&scoped=true"
import script from "./JobTemplateSelection.vue?vue&type=script&lang=js"
export * from "./JobTemplateSelection.vue?vue&type=script&lang=js"

import "./JobTemplateSelection.vue?vue&type=style&index=0&id=7d96a5e6&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d96a5e6"]])

export default __exports__